import AbstractValidator from './AbstractValidator';

export default class Identical extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        notSame: 'Die angegebenen Token stimmen nicht miteinander überein',
        missingToken: 'Es wurde kein Token angegeben',
    };

    run()
    {
        if (!this.token)
        {
            this.error = this.getMessage('missingToken');
            return;
        }

        let value;

        if (!this.literal)
        {
            let el = window.document.querySelector(`[name=${this.token}]`) as HTMLInputElement;

            if (el)
            {
                value = el.value;
            }
            else
            {
                this.error = this.getMessage('notSame');
                return;
            }
        }
        else
        {
            value = this.token;
        }

        if (this.strict && value !== this.value || !this.strict && value != this.value)
        {
            this.error = this.getMessage('notSame');
        }
    }

    get token()
    {
        return this._options && this._options.token ? this._options.token : null;
    }

    get literal()
    {
        return !!this._options.literal;
    }

    get strict()
    {
        return !!this._options.strict;
    }
}